import React from "react";
import { makeStyles } from "@material-ui/styles";
import Particles from "react-particles-js";
import { Typography, Box, Grid, Button } from "@material-ui/core";
import { ReactComponent as Astro } from "../../assets/images/astronaut.svg";

import styled from "styled-components";
import { useState } from "react";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { SetUserAccess } from "../../actions";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#1c1f23",
  },
  particle: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
  },
  content: {
    zIndex: 9999,
  },
}));

const AutoLogin = (props) => {
  const classes = useStyles();
  const [top, setTop] = useState(100);
  const [left, setLeft] = useState(100);
  const [transform, setTransform] = useState(30);
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const dispatch = useDispatch();

  const Token = props.Token;
  const CustomerId = props.CustomerId;
  if (Token !== undefined) {
    dispatch(SetUserAccess(Token, "", "", CustomerId, "", Date.now()));
    history.push("/my-websites");
  }

  return (
    <div className={classes.root}>
      <Grid
        className={classes.content}
        direction="column"
        alignItems="center"
        justify="center"
        container
      >
        <Grid item>
          <Box fontWeight={900} fontSize="10rem" color="white">
            {t("Redirecting...")}
          </Box>
        </Grid>
        <Grid md={4} item>
          <Box
            marginTop="-20px"
            textAlign="center"
            fontSize="1.5rem"
            color="white"
          >
            {t("For Automatic Login Please Wait")}
          </Box>
        </Grid>
      </Grid>

      <Particles
        className={classes.particle}
        params={{
          fps_limit: 60,
          particles: {
            number: {
              value: 355,
              density: {
                enable: true,
                value_area: 789.1476416322727,
              },
            },
            color: {
              value: "#ffffff",
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#000000",
              },
              polygon: {
                nb_sides: 5,
              },
              image: {
                src: "img/github.svg",
                width: 100,
                height: 100,
              },
            },
            opacity: {
              value: 0.48927153781200905,
              random: false,
              anim: {
                enable: true,
                speed: 0.2,
                opacity_min: 0,
                sync: false,
              },
            },
            size: {
              value: 2,
              random: true,
              anim: {
                enable: true,
                speed: 1,
                size_min: 0,
                sync: false,
              },
            },
            line_linked: {
              enable: false,
              distance: 150,
              color: "#ffffff",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 0.644,
              direction: "left",
              random: false,
              straight: true,
              out_mode: "out",
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "bubble",
              },
              onclick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 83.91608391608392,
                size: 1,
                duration: 3,
                opacity: 1,
                speed: 3,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: false,
        }}
      />
    </div>
  );
};

export default AutoLogin;
